import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-general-textarea-modal',
  templateUrl: './general-textarea-modal.component.html',
  styleUrls: ['./general-textarea-modal.component.scss']
})
export class GeneralTextareaModalComponent implements OnInit {

  public userInput: FormControl = new FormControl(null, Validators.required);

  ngOnInit() {
  }

  constructor(
    public dialogRef: MatDialogRef<GeneralTextareaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { header: string, text: string, label: string, button: string, modalParam: any}) {
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  sendResult() {
    this.dialogRef.close({ status : true, data : this.userInput.value});
  }

}
